import React from 'react';
import { DragSource } from 'react-dnd';
import { CONTENT_DND_TYPE } from '@go-client/components/DraggableContentItem';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';
import { collectSource, contentDragSource } from '@go-client/lib/feedEditor';

interface DraggableEventRundownProps {
  connectDragSource?: any;
  isDragging?: boolean;
  contentTemplate: BareContentTemplateLegacy;
  onDragStart?: () => void;
}

const DraggableEventRundown: React.FC<DraggableEventRundownProps> = ({
  connectDragSource,
  isDragging,
}) => {
  let bgColor = isDragging ? 'bg-blue-light' : 'bg-white';
  return connectDragSource(
    <div
      className={`FeedDraggableContentItem p-2 cursor-move shadow rounded-sm border-l-8 border-lime ${bgColor}`}
    >
      <h1 className="text-sm font-semibold uppercase">Event Rundown</h1>
      <div className="text-xs">Drag this into an empty content area to create an event rundown</div>
    </div>
  );
};

export default DragSource(
  CONTENT_DND_TYPE,
  contentDragSource<DraggableEventRundownProps>(),
  collectSource
)(DraggableEventRundown);
